import React from "react";

export const TikTokIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M16.6 5.82a4.28 4.28 0 0 1-2.63-2.4A4.4 4.4 0 0 1 13.7 2h-3.14v13.4a2.6 2.6 0 1 1-1.86-2.49V9.66a5.9 5.9 0 1 0 5 5.83V9.02a7.6 7.6 0 0 0 4.4 1.4V7.3a4.28 4.28 0 0 1-1.5-1.48Z" />
  </svg>
);
